/**
 * E5 장례식장 명칭 퍼널 실험 대상: 검색광고(네이버 SA · 구글 광고)로 이 페이지에 들어온 사람만(2026-11-05 주완: 네이버 · 구글 같이).
 *
 * 오가닉은 넣지 않는다. 기저 전환율이 유입마다 크게 달라(parlorRequestAdEntry.ts 주석) 섞으면 결과가 흔들린다.
 * 광고 파라미터는 새로고침 · 페이지 안 이동에서 사라지므로 첫 진입에 탭 단위로 표시해 둔다(parlorRequestAdEntry 와 같은 방식).
 */

const PAID_SEARCH_ENTRY_KEY = "parlor_e5_paid_search_entry";

/** 네이버 SA(n_media · n_query · n_ad_group · n_ad) 또는 구글 광고(gclid · gad_source) 랜딩 파라미터 */
const hasPaidSearchParams = (query: Record<string, unknown>): boolean =>
  "n_media" in query ||
  "n_query" in query ||
  "n_ad_group" in query ||
  "n_ad" in query ||
  "gclid" in query ||
  "gad_source" in query;

/** 첫 진입의 검색광고 유입을 탭에 남긴다. effect 에서 호출 */
export const markE5PaidSearchEntry = (query: Record<string, unknown>) => {
  if (typeof window === "undefined" || !hasPaidSearchParams(query)) return;
  try {
    sessionStorage.setItem(PAID_SEARCH_ENTRY_KEY, "1");
  } catch {
    // 쓰기 실패(사파리 프라이빗 등)면 파라미터가 살아 있는 동안만 대상이 된다
  }
};

/**
 * E5 실험 대상인지(읽기 전용). router.isReady 이후에 부른다.
 * @param query router.query
 */
export const isE5PaidSearchEntry = (query: Record<string, unknown>): boolean => {
  if (hasPaidSearchParams(query)) return true;
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(PAID_SEARCH_ENTRY_KEY) !== null;
  } catch {
    return false;
  }
};
